var _path, _path2, _path3, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVidOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.0001L16.5267 9.73671C18.0834 8.95836 18.8618 8.56918 19.4309 8.92092C20 9.27265 20 10.1429 20 11.8833V12.1168C20 13.8572 20 14.7275 19.4309 15.0792C18.8618 15.4309 18.0834 15.0418 16.5267 14.2634L16 14.0001V10.0001Z",
    stroke: "#1A1B1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2477 8.35147C13.7164 8.8201 13.7164 9.5799 13.2477 10.0485C12.7791 10.5172 12.0193 10.5172 11.5507 10.0485C11.0821 9.5799 11.0821 8.8201 11.5507 8.35147C12.0193 7.88284 12.7791 7.88284 13.2477 8.35147Z",
    stroke: "#1A1B1B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.6001C4 8.97011 4 7.65512 4.72637 6.77004C4.85934 6.60801 5.00791 6.45944 5.16994 6.32646C6.05502 5.6001 7.37001 5.6001 10 5.6001C12.63 5.6001 13.945 5.6001 14.8301 6.32646C14.9921 6.45944 15.1407 6.60801 15.2736 6.77004C16 7.65512 16 8.97011 16 11.6001V12.4001C16 15.0301 16 16.3451 15.2736 17.2302C15.1407 17.3922 14.9921 17.5408 14.8301 17.6737C13.945 18.4001 12.63 18.4001 10 18.4001C7.37001 18.4001 6.05502 18.4001 5.16994 17.6737C5.00791 17.5408 4.85934 17.3922 4.72637 17.2302C4 16.3451 4 15.0301 4 12.4001V11.6001Z",
    stroke: "#1A1B1B",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.3536,
    y1: 3.35355,
    x2: 3.35355,
    y2: 21.3536,
    stroke: "#1A1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidOff);
export default __webpack_public_path__ + "static/media/vid-off.36fc6686c2ef39768a2e457cbf87d65b.svg";
export { ForwardRef as ReactComponent };